import { Loader2, Upload } from "lucide-react"

interface UploadingOverlayProps {
  currentMessageIndex: number
  messages: string[]
}

export function UploadingOverlay({
  currentMessageIndex,
  messages,
}: UploadingOverlayProps) {
  return (
    <div className="tw-fixed tw-inset-0 tw-bg-black/50 tw-backdrop-blur-sm tw-z-50 tw-flex tw-flex-col tw-items-center tw-justify-center">
      <div className="tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-p-8 tw-max-w-md tw-mx-4">
        <div className="tw-flex tw-flex-col tw-items-center tw-gap-6">
          <div className="tw-relative">
            <Loader2 className="tw-w-16 tw-h-16 tw-text-emerald-600 tw-animate-spin" />
            <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
              <Upload className="tw-w-8 tw-h-8 tw-text-emerald-600/50" />
            </div>
          </div>
          <div className="tw-text-center tw-space-y-2">
            <h3 className="tw-text-xl tw-font-semibold tw-text-gray-900">
              {messages[currentMessageIndex]}
            </h3>
            <p className="tw-text-sm tw-text-gray-600">
              Please wait while we process your files
            </p>
          </div>
          <div className="tw-flex tw-gap-2">
            {messages.map((_, index) => (
              <div
                key={index}
                className={`tw-w-2 tw-h-2 tw-rounded-full tw-transition-all tw-duration-300 ${
                  index === currentMessageIndex
                    ? "tw-bg-emerald-600 tw-scale-125"
                    : index < currentMessageIndex
                      ? "tw-bg-emerald-400"
                      : "tw-bg-gray-300"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
